




export default angular.module('sharable-dashboard.state-service', [
]).factory('stateService', [function() {
    return {
        generationProgressHandle: null,
        entitlements: []
    }
}]);